import { RegisteredComponent } from "@builder.io/sdk-react";

export const slidesBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Slides",
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/ty-icon/layout-slider.png",
  noWrap: true,
  requiresParent: {
    message: "This component must be nested within the Slider component.",
    component: "Slider",
  },
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
    builderContext: true,
  },
  defaultStyles: {
    width: "100%",
  },
  inputs: [
    {
      name: "slides",
      type: "list",
      subFields: [
        {
          name: "slide",
          type: "uiBlocks",
          defaultValue: [],
        },
      ],
    },
    {
      name: "fade",
      type: "boolean",
      helperText: "Change the animation from slide moving to fade effect.",
      defaultValue: false,
      required: false,
      localized: false,
    },
  ],
};
